module.exports = __webpack_public_path__ + "static/media/Twitter.13c5697b.png";